import { render, staticRenderFns } from "./EmailTpl.vue?vue&type=template&id=ed2f8c08&scoped=true&"
import script from "./EmailTpl.vue?vue&type=script&lang=js&"
export * from "./EmailTpl.vue?vue&type=script&lang=js&"
import style0 from "./EmailTpl.vue?vue&type=style&index=0&id=ed2f8c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2f8c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed2f8c08')) {
      api.createRecord('ed2f8c08', component.options)
    } else {
      api.reload('ed2f8c08', component.options)
    }
    module.hot.accept("./EmailTpl.vue?vue&type=template&id=ed2f8c08&scoped=true&", function () {
      api.rerender('ed2f8c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/components/EmailTpl.vue"
export default component.exports